export default __webpack_public_path__ + "static/media/Illustration.6a5e1eb8.svg";